import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const StreetNumber = () => {
  const { t, updateAddress, errors, streetNumber, streetName, city, showAddressFields } = useAddress()

  if (!showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('streetNumber', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.street_number')}
        onBlur={streetNumber =>
          updateAddress({ streetNumber, label: (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (city ?? '') })
        }
        currentValue={streetNumber}
      />
    </FormControl>
  )
}

export default StreetNumber
